import { Box, Chip } from '@mui/material'
import React from 'react'
import { green } from '../../../../colors'
import { type ISectionSettings } from '../../../../store/slices/SurveyTemplateSlice'
import { TEACHING_ROLE_OPTIONS } from '../../constant'

interface IsRepeatPerInstructorProps {
  settings: ISectionSettings
}
const IsRepeatPerInstructor: React.FC<IsRepeatPerInstructorProps> = ({ settings }) => {
  if (!settings?.isRepeatPerInstructor) {
    return <></>
  }

  const selectedRoles = settings?.selectedRoles ?? []
  const allTeachingRoleValues = TEACHING_ROLE_OPTIONS.map((option) => option.value)
  const hasAllTeachingRoles = allTeachingRoleValues.every((role) => selectedRoles.includes(role))
  const selectedRolesLabel = hasAllTeachingRoles
    ? 'All Teaching Roles'
    : selectedRoles.map((role) => TEACHING_ROLE_OPTIONS.find((option) => option.value === role)?.label).join(', ')

  const label = (
    <>
      Repeat per Instructor ({selectedRolesLabel})
      {settings?.isSelectInstructorEnabled && (
        <Box component="span" sx={{ fontWeight: 600, display: 'inline', ml: 0.5 }}>
          : User Select
        </Box>
      )}
    </>
  )

  return (
    <Chip
      label={label}
      variant="filled"
      size="small"
      color="success"
      sx={{
        borderRadius: '6px',
        border: `1px solid ${green[50]}`,
        fontWeight: 500,
        color: green[100],
        backgroundColor: green[0]
      }}
    />
  )
}

export default React.memo(IsRepeatPerInstructor)
